// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__5VV-8","reportBodyText":"style__reportBodyText__EdXUh"};